<template>
    <h1>All Products</h1>
</template>

<script>
//   const API_URL = 'http://localhost:4000'
   export default {
       name: 'CategoryProduct'
   }
</script>
